var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 156.187,
    height: 146.496,
    viewBox: "0 0 156.187 146.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#bdbdbd}.cls-1{opacity:.255}.cls-12,.cls-3{opacity:.5}.cls-4{fill:url(#linear-gradient)}.cls-5{fill:#fafafa}.cls-6{fill:url(#linear-gradient-2)}.cls-7{fill:url(#linear-gradient-3)}.cls-8{fill:url(#linear-gradient-4)}.cls-9{fill:#fff}.cls-10{fill:url(#linear-gradient-5)}.cls-11,.cls-12{fill:#616161}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.509,
    x2: 0.509,
    y1: 0.997,
    y2: -0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.813,
    x2: 0.813,
    y1: 0.841,
    y2: -0.159,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.78,
    x2: 1.78,
    y1: 0.849,
    y2: -0.151,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y1: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y1: 0.999,
    y2: -0.001,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty-state_solicitud",
    transform: "translate(4.179 9.532)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_205",
    cx: 67,
    cy: 66.5,
    className: "cls-1",
    "data-name": "Elipse 205",
    rx: 67,
    ry: 66.5,
    transform: "translate(6.83 3.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_859",
    d: "M0 0h78.77v108.834H0z",
    className: "cls-2",
    "data-name": "Rect\\xE1ngulo 859",
    transform: "rotate(-12.12 121.222 -46.46)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_940",
    className: "cls-3",
    "data-name": "Grupo 940",
    transform: "translate(14.147 9.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_860",
    d: "M0 0h76.108v105.156H0z",
    className: "cls-4",
    "data-name": "Rect\\xE1ngulo 860",
    transform: "matrix(.978 -.21 .21 .978 0 15.967)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_861",
    d: "M0 0h74.17v102.832H0z",
    className: "cls-5",
    "data-name": "Rect\\xE1ngulo 861",
    transform: "matrix(.978 -.21 .21 .978 15.256 26.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_862",
    d: "M0 0h36.795v8.913H0z",
    className: "cls-6",
    "data-name": "Rect\\xE1ngulo 862",
    transform: "matrix(.978 -.21 .21 .978 32.687 18.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1842",
    d: "M442.532 91.386a5.267 5.267 0 1 0 6.128 4.07 5.205 5.205 0 0 0-6.128-4.07zm1.743 8.129a3.039 3.039 0 1 1 2.264-3.6 3 3 0 0 1-2.264 3.6z",
    className: "cls-7",
    "data-name": "Trazado 1842",
    transform: "translate(-393.684 -85.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_863",
    d: "M0 0h36.02v8.52H0z",
    className: "cls-2",
    "data-name": "Rect\\xE1ngulo 863",
    transform: "matrix(.978 -.21 .21 .978 32.986 17.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1843",
    d: "M442.834 91.385a5.034 5.034 0 1 0 5.979 3.866 5.034 5.034 0 0 0-5.979-3.866zm1.665 7.768a2.906 2.906 0 1 1 2.232-3.45 2.906 2.906 0 0 1-2.231 3.451z",
    className: "cls-2",
    "data-name": "Trazado 1843",
    transform: "translate(-393.987 -85.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_864",
    d: "M0 0h78.77v108.834H0z",
    className: "cls-2",
    "data-name": "Rect\\xE1ngulo 864",
    transform: "translate(46.483 21.072)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_941",
    className: "cls-3",
    "data-name": "Grupo 941",
    transform: "translate(47.815 22.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_865",
    d: "M0 0h76.108v105.156H0z",
    className: "cls-8",
    "data-name": "Rect\\xE1ngulo 865"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_866",
    d: "M0 0h74.17v102.832H0z",
    className: "cls-9",
    "data-name": "Rect\\xE1ngulo 866",
    transform: "translate(48.783 23.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_867",
    d: "M0 0h36.795v8.913H0z",
    className: "cls-2",
    "data-name": "Rect\\xE1ngulo 867",
    transform: "translate(67.568 19.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1844",
    d: "M643.464 118a5.268 5.268 0 1 0 5.144 5.267 5.206 5.206 0 0 0-5.144-5.267zm0 8.306a3.039 3.039 0 1 1 2.967-3.039 3 3 0 0 1-2.967 3.024z",
    className: "cls-10",
    "data-name": "Trazado 1844",
    transform: "translate(-557.499 -107.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1845",
    d: "M643.964 118a5.034 5.034 0 1 0 5.036 5.034 5.034 5.034 0 0 0-5.036-5.034zm0 7.94a2.948 2.948 0 1 0 0-.009z",
    className: "cls-2",
    "data-name": "Trazado 1845",
    transform: "translate(-557.999 -107.472)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_944",
    "data-name": "Grupo 944",
    transform: "translate(-4.179 -3.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_942",
    className: "cls-3",
    "data-name": "Grupo 942",
    transform: "translate(3.236 101.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_869",
    d: "M0 0h1.829v10.373H0z",
    className: "cls-11",
    "data-name": "Rect\\xE1ngulo 869",
    transform: "translate(4.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_870",
    d: "M0 0h1.829v10.373H0z",
    className: "cls-11",
    "data-name": "Rect\\xE1ngulo 870",
    transform: "rotate(90 3.049 7.324)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_945",
    className: "cls-3",
    "data-name": "Grupo 945",
    transform: "rotate(14 -449.696 644.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_869-2",
    d: "M0 0h1.829v10.373H0z",
    className: "cls-11",
    "data-name": "Rect\\xE1ngulo 869",
    transform: "translate(4.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_870-2",
    d: "M0 0h1.829v10.373H0z",
    className: "cls-11",
    "data-name": "Rect\\xE1ngulo 870",
    transform: "rotate(90 3.049 7.324)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_943",
    className: "cls-3",
    "data-name": "Grupo 943",
    transform: "translate(84.306 -5.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_871",
    d: "M0 0h1.695v9.616H0z",
    className: "cls-11",
    "data-name": "Rect\\xE1ngulo 871",
    transform: "translate(3.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_872",
    d: "M0 0h1.695v9.616H0z",
    className: "cls-11",
    "data-name": "Rect\\xE1ngulo 872",
    transform: "rotate(90 2.829 6.787)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1847",
    d: "M314.115 620.185a.878.878 0 0 1-.489-1.061.426.426 0 0 0 .019-.1.44.44 0 0 0-.79-.291.422.422 0 0 0-.05.086.878.878 0 0 1-1.061.489.422.422 0 0 0-.1-.019.44.44 0 0 0-.291.79.423.423 0 0 0 .086.049.878.878 0 0 1 .489 1.061.422.422 0 0 0-.019.1.44.44 0 0 0 .79.291.428.428 0 0 0 .05-.086.878.878 0 0 1 1.061-.49.421.421 0 0 0 .1.019.44.44 0 0 0 .291-.79.432.432 0 0 0-.086-.048z",
    className: "cls-12",
    "data-name": "Trazado 1847",
    transform: "translate(-288.089 -512.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1848",
    d: "M842.525 120.865a.878.878 0 0 1-.489-1.061.422.422 0 0 0 .019-.1.44.44 0 0 0-.79-.291.416.416 0 0 0-.049.086.878.878 0 0 1-1.061.489.424.424 0 0 0-.1-.019.44.44 0 0 0-.291.79.422.422 0 0 0 .086.05.878.878 0 0 1 .49 1.061.421.421 0 0 0-.019.1.44.44 0 0 0 .79.291.423.423 0 0 0 .049-.086.878.878 0 0 1 1.061-.489.424.424 0 0 0 .1.019.44.44 0 0 0 .292-.79.422.422 0 0 0-.086-.05z",
    className: "cls-12",
    "data-name": "Trazado 1848",
    transform: "translate(-715.872 -107.881)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_200",
    cx: 1.434,
    cy: 1.434,
    r: 1.434,
    className: "cls-12",
    "data-name": "Elipse 200",
    transform: "translate(153.319 58.451)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_202",
    cx: 2.934,
    cy: 2.934,
    r: 2.934,
    className: "cls-12",
    "data-name": "Elipse 202",
    transform: "translate(138.593 89.446)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_203",
    cx: 1.434,
    cy: 1.434,
    r: 1.434,
    className: "cls-12",
    "data-name": "Elipse 203",
    transform: "translate(15.16 16.914)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_204",
    cx: 1.434,
    cy: 1.434,
    r: 1.434,
    className: "cls-12",
    "data-name": "Elipse 204",
    transform: "translate(0 56.031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.bd9a0c4627e1876777aff70eaa404b09.svg";
export { ForwardRef as ReactComponent };